import { inject, Service } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertAuraComponent, AlertData } from '../components/layouts/alert/alert.component';
import { AuraColorType } from '../utils';

export interface AlertSnackBarOptions {
  duration?: number;
  dismissible?: boolean;
  showIcon?: boolean;
  panelClass?: string | string[];
}

export interface AlertSnackBarArgs extends AlertSnackBarOptions {
  message?: string;
  title?: string;
}

@Service()
export class AlertSnackBarService {
  snackBar = inject(MatSnackBar);

  open(alert: AlertData, options?: AlertSnackBarOptions) {
    const { duration = 5000, dismissible = true, showIcon = true, panelClass } = options ?? {};

    const panelClasses = ['aura-alert-snackbar'];
    if (panelClass) {
      if (Array.isArray(panelClass)) {
        panelClasses.push(...panelClass);
      } else {
        panelClasses.push(panelClass);
      }
    }

    return this.snackBar.openFromComponent(AlertAuraComponent, {
      duration,
      data: { alert, dismissible, showIcon },
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: panelClasses,
    });
  }

  success(args: AlertSnackBarArgs) {
    return this.open({ message: args.message, title: args.title, type: AuraColorType.SUCCESS }, args);
  }

  error(args: AlertSnackBarArgs) {
    return this.open({ message: args.message, title: args.title, type: AuraColorType.ERROR }, args);
  }

  warn(args: AlertSnackBarArgs) {
    return this.open({ message: args.message, title: args.title, type: AuraColorType.WARN }, args);
  }

  info(args: AlertSnackBarArgs) {
    return this.open({ message: args.message, title: args.title, type: AuraColorType.INFO }, args);
  }
}
